import isNil from 'lodash/isNil';
import sumBy from 'lodash/sumBy';

import { currencyFormatter } from 'utils';

export const downloadFile = ({ response, file }) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${file.name}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const downloadRequestHeaders = {
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/json',
    Accept: `application/pdf`,
  },
};


// function calculateBusinessPlanDetails
// this function creates and initializes businessPlanDetails object from payload,
// we also use this function to get the list of properties in businessPlanDetails by
// calling it without a payload, e.g. Object.keys(calculateBusinessPlanDetails()),
// for this reason we first check if payload exists by using optional chaining operator (?.)
// and isNil()

export const calculateRestDetails = payload => {
  return {
    companySize: payload?.companySize,
    companyLegalType: payload?.companyLegalType,
    eligibilityCheck: payload?.eligibilityCheck,
    investmentPlanElements: payload?.investmentPlanElements,
  };
};

export const euroFormatter = new Intl.NumberFormat('el-GR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export const printInfo = info => {
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return info;
  }
};

export const printValue = info => {
  if (typeof info === 'undefined' || info === null || info.length === 0) {
    return '-';
  } else {
    return info + ' €';
  }
};

export const calculateBusinessPlanOverviewTables = payload => {
  // console.log(sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice'))
  return {
    InvestmentTotalAmountTable: isNil(payload) || isNil(payload.businessPlanDetails.businessPlanAssets)
      ? []
      : [
        {
          title: "Ιδία Συμμετοχή",
          SumTotalExpense: isNil(sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')) ? currencyFormatter(0) :
          currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
            - sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')
          ),
          SumTotalApprove: isNil(sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')) ? currencyFormatter(0) :
          sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp') <= 400000 ? 
          currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
            - sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')
          ) : 
          currencyFormatter(sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice') - 400000),
        },
        {
          title: "Δημόσια Δαπάνη",
          SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')
          ),
          SumTotalApprove: sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp') <= 400000 || isNil(sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')) ? 
          currencyFormatter(sumBy(payload.businessPlanDetails.businessPlanAssets, 'publicExp')) : currencyFormatter(400000),
        },
        {
          title: "Σύνολο",
            SumTotalExpense: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
          ),
          SumTotalApprove: currencyFormatter(
            sumBy(payload.businessPlanDetails.businessPlanAssets, 'totalPrice')
          ),
        },
      ]
  }
}